module.exports.morgana = {
  vi: {
    title: 'Morgana trong Avalon: năng lực và chiến thuật',
    description:
      'Morgana trong Avalon: vì sao Percival thấy cô như một ứng viên Merlin, vì sao Merlin vẫn thấy cô thuộc phe Ác và cách tận dụng lớp ngụy trang trong các Nhiệm vụ.',
    keywords: ['Morgana', 'Vai trò', 'Luật chơi', 'Mẹo chơi'],
  },
  pt: {
    title: 'Morgana em Avalon: habilidades e estratégia',
    description:
      'Morgana em Avalon: por que Percival a vê como candidata a Merlin, por que Merlin sabe que ela é má e como usar o disfarce nas missões.',
    keywords: ['Morgana', 'Papel', 'Regras', 'Dicas'],
  },
  en: {
    title: 'Morgana in Avalon: Abilities & Strategy',
    description:
      'Morgana in Avalon: why Percival sees her as a Merlin candidate, why Merlin still sees her as evil, and how to use the disguise during missions.',
    keywords: ['Morgana', 'Role', 'Rules', 'Tips'],
  },
  ru: {
    title: 'Моргана в Авалоне: способности и стратегия',
    description:
      'Моргана в Авалоне: почему Персиваль принимает её за кандидата на Мерлина, что видит сам Мерлин и как использовать маскировку на миссиях.',
    keywords: ['Моргана', 'Роль', 'Правила', 'Советы'],
  },
  'zh-TW': {
    title: '阿瓦隆莫甘娜：角色能力與玩法策略',
    description: '阿瓦隆莫甘娜：為什麼派西維爾把她視為梅林候選人，梅林為什麼仍知道她是壞人，以及如何在任務中利用偽裝。',
    keywords: ['莫甘娜', '角色', '規則', '建議'],
  },
  'zh-CN': {
    title: '阿瓦隆莫甘娜：角色能力与玩法策略',
    description: '阿瓦隆莫甘娜：为什么派西维尔把她视为梅林候选人，梅林为什么仍知道她是坏人，以及如何在任务中利用伪装。',
    keywords: ['莫甘娜', '角色', '规则', '建议'],
  },
  es: {
    title: 'Morgana en Avalon: habilidades y estrategia',
    description:
      'Morgana en Avalon: por qué Percival la ve como candidata a Merlín, por qué Merlín sabe que es malvada y cómo usar el disfraz durante las misiones.',
    keywords: ['Morgana', 'Rol', 'Reglas', 'Consejos'],
  },
};
